// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"02ea36ce","84":"c94b6abb","439":"e28fd4cd","458":"9ee8ea42","497":"39fa7d81","774":"76e620ff","787":"d97f5028","858":"151b2afe","885":"cb368944"}[chunkId] + ".chunk.js";
};